export function appendUniqueResources(existing = [], incoming = []) {
  const seen = new Set(existing.map((row) => String(row?.id || '')))
  const next = existing.slice()
  for (const row of incoming) {
    const id = String(row?.id || '')
    if (!id || seen.has(id)) continue
    seen.add(id)
    next.push(row)
  }
  return next
}

export function cloudFailureCode(status, body) {
  const code = typeof body?.code === 'string' ? body.code : ''
  if (status === 403 || code === 'ORGANIZATION_PERMISSION_DENIED') return 'ORGANIZATION_PERMISSION_DENIED'
  if (typeof body?.error === 'string' && body.error && body.error !== 'Forbidden') return body.error
  return 'CLOUD_ERROR'
}

export function acceptScopedResponse(ticket, current) {
  if (!current?.orgId) return false
  if (!ticket || ticket.generation !== current.generation) return false
  if (ticket.orgId !== current.orgId) return false
  if (ticket.selectedId != null && ticket.selectedId !== current.selectedId) return false
  return true
}

function cloudError() {
  const error = new Error('CLOUD_ERROR')
  error.code = 'CLOUD_ERROR'
  return error
}

export function readProposalQueueResponse(ok, body) {
  if (!ok || !body || typeof body !== 'object' || body.error) {
    return {
      items: [],
      counts: null,
      notice: null,
      nextCursor: null,
      error: typeof body?.error === 'string' && body.error ? body.error : 'CLOUD_ERROR',
    }
  }
  return {
    items: Array.isArray(body.items) ? body.items : [],
    counts: body.counts && typeof body.counts === 'object' ? body.counts : null,
    notice: body.notice || null,
    nextCursor: body.nextCursor || null,
    totalNew: body.totalNew,
    error: null,
  }
}

export function buildCloudRequestUrl(apiBase, path, orgId) {
  if (typeof orgId !== 'string' || orgId === '') throw cloudError()
  const input = typeof path === 'string' ? path : ''
  if (input.includes('\\') || input.startsWith('//') || /^[a-z][a-z0-9+.-]*:/i.test(input) || input.includes('#')) {
    throw cloudError()
  }
  const splitAt = input.indexOf('?')
  const route = splitAt === -1 ? input : input.slice(0, splitAt)
  const search = splitAt === -1 ? '' : input.slice(splitAt + 1)
  if (route !== '' && !route.startsWith('/')) throw cloudError()

  const baseText = typeof apiBase === 'string' && apiBase.trim() !== '' ? apiBase.trim() : '/api'
  const absolute = /^https?:\/\//i.test(baseText)
  const baseUrl = absolute ? new URL(baseText) : new URL(baseText, 'https://defendsphere.invalid')
  if (baseUrl.username || baseUrl.password) throw cloudError()
  const prefix = `${baseUrl.pathname.replace(/\/$/, '')}/integrations/cloud`
  const target = new URL(`${prefix}${route}`, baseUrl.origin)
  const samePath = target.pathname === prefix || target.pathname.startsWith(`${prefix}/`)
  if (target.origin !== baseUrl.origin || !samePath) throw cloudError()
  const params = new URLSearchParams(search)
  params.set('organization_id', orgId)
  target.search = params.toString()
  if (!absolute) return `${target.pathname}${target.search}`
  return target.toString()
}

export function resolveSelectionResults(ticket, current, settled) {
  if (!acceptScopedResponse(ticket, current)) return { accepted: false }
  const runsOk = settled?.runs?.status === 'fulfilled'
  const resourcesOk = settled?.resources?.status === 'fulfilled'
  const result = { accepted: true, runs: null, resources: null, nextOffset: null, error: null }
  if (runsOk) {
    const value = settled.runs.value
    result.runs = Array.isArray(value?.runs) ? value.runs : []
  }
  if (resourcesOk) {
    const value = settled.resources.value
    result.resources = Array.isArray(value?.items) ? value.items : []
    result.nextOffset = typeof value?.nextOffset === 'number' ? value.nextOffset : null
  }
  if (!runsOk || !resourcesOk) {
    const reason = !runsOk ? settled?.runs?.reason : settled?.resources?.reason
    result.error = reason instanceof Error && reason.message ? reason.message : 'CLOUD_ERROR'
  }
  return result
}
